module.exports = {"user":{"name":"个人中心","icon":"fa fa-user","ref":"folder_user","childrens":{"normaltodo":{"name":"待办任务","href":"/user/taskTodo","ref":"car_user_todo","icon":"fa fa-calendar-o"},"normaldone":{"name":"已办任务","href":"/user/taskList","ref":"car_user_task","icon":"fa fa-calendar-check-o"},"personal":{"name":"个人资料","href":"/user/info","ref":"car_user_info","icon":"fa fa-user"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/part/system/menuCfg/car.json
// module id = 1055
// module chunks = 105